"use client";
import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

export interface DualRangeSliderProps {
  value: [number, number];
  onChange: (val: [number, number]) => void;
  min?: number;
  max?: number;
}

export const DualRangeSlider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  DualRangeSliderProps
>(({ value, onChange, min = 100, max = 1000 }, ref) => (
  <div className="p-4 bg-white rounded-lg shadow">
    <SliderPrimitive.Root
      ref={ref}
      className="relative flex select-none items-center w-full h-6"
      min={min}
      max={max}
      value={value}
      onValueChange={onChange}
    >
      <SliderPrimitive.Track className="relative h-2 flex-grow bg-gray-200 rounded-full">
        <SliderPrimitive.Range className="absolute h-full bg-green-500 rounded-full" />
      </SliderPrimitive.Track>
      {value.map((_, i) => (
        <SliderPrimitive.Thumb
          key={i}
          className="block h-4 w-4 bg-white border-2 border-primary rounded-full shadow -mt-1 cursor-pointer"
        />
      ))}
    </SliderPrimitive.Root>
  </div>
));
DualRangeSlider.displayName = "DualRangeSlider";
